module.exports = __webpack_public_path__ + "img/bg-season1.867884e3.png";